module.exports = __webpack_public_path__ + "static/media/OpenEnglishJunior.3e8315b3.png";